<div class="lds-container scroll d-flex flex-wrap justify-content-center p-2">
  @for (energyFeatureSet of featureSetsWithData; track energyFeatureSet) {
    <lds-featureset-card [featureSet]='energyFeatureSet'>
    </lds-featureset-card>
  }
</div>

<!-- <div class="lw-container scroll" fxLayoutWrap="row" fxLayoutAlign="space-around start" *ngIf="type==='energy'">
<app-device-list-card *ngFor="let key of object.keys(energyData.featureSetsWithData)" [device]='energyData.featureSetsWithData[key]' (uploaded)='elementClicked($event)'>
</app-device-list-card>
<app-device-list-card *ngFor="let key of object.keys(energyData.featureSetsWithoutData)" [device]='energyData.featureSetsWithoutData[key]' noData="true">
</app-device-list-card>
</div> -->
